<svelte:head>

	{#if $activity && $activity.settings}
		<title>{$activity.titles[0]}</title>
	<meta name='description' content='{$activity.settings.desc}'>

	<meta name="twitter:site" content="@mspanish">
	<meta name="twitter:title" content="{$activity.titles[0]}">
	<meta name="twitter:description" content="{$activity.settings.desc}">
	<meta name="twitter:creator" content="@mspanish">
	<meta name="twitter:image" content="{$activity.settings.img.replace('../', 'https://talker.netlify.com/')}">
	
	<meta property="og:title" content="{$activity.titles[0]}" />
	<meta property="og:type" content="article" />
	<meta property="og:url" content="https://talker.netlify.com/{$activity.settings.name}.html" />
	<meta property="og:image" content="{$activity.settings.img.replace('../', 'https://talker.netlify.com/')}" />
	<meta property="og:description" content="{$activity.settings.desc}" />
	
	{/if}
</svelte:head>


<Sharing bind:activity=$activity/>
<div class="content is-medium">
  <h1>The Talker: AAC Device and Literacy Materials</h1>
  
 <p>This year our nonverbal autistic 6 year old daughter, affectionately known as "TT", began using an Augmentative and Alternative Communication (AAC) device, and it's been life changing for her. We've learned, among many other things, that she loves to bake!</p>
  
    <div class="cardsWrap">
   <img class="card" src="../img/baker.jpg">
  </div>
  
  <p>We were lucky that we happened to have a perfect tablet that had been nearly unused for 4 years, and I was able to refashion it into a dedicated AAC device, and customize it with icons and other pages I created to help her begin talking. We were able to begin using a top notch AAC software, <a hre="https://www.tobiidynavox.com/en-us/software/windows-software/snap-for-windows/" target="_blank">Snap Core First</a> by Tobii Dynavox - with a child voice called Nelly, for just $4.99 a month.</p>

  <p>For most people, acquiring a speech device is nowhere near that cheap or simple! In fact, most families end up waiting somewhere between 3 to 6 months in order for all of the funding aspects to come through for an insurance paid device. Some of these devices are impossible to get without insurance: our SLP (speech therapist) received a quote for a 10 inch device that they wanted to bill our insurance $6,000 for! If you have the know how to do it yourself, you still may end up looking at about $700 to $800 for a brand new device, along with software like Proloquo2Go, which is what many SLPs are familiar with (Snap Core was only released last spring).</p> 
  
  
  <p>We've been so delighted with the setup for TT's talker, that I thought it might be nice to put together a few additional devices and sell them online to other families who would like access to a lower cost, kid tested setup, along with a variety of pre-created pages you can choose to use, as well as a custom graphic icons set I developed to match another project of mine, Learn to Read Visually. Here you see TT completing a colors/numbers activity using her talker.</p>

  <div class="cardsWrap">
   <img class="card" src="../img/tt_colorful.jpg">
  </div>
  
  <p>8 inch tablets are fantastic for kids to use as a dedicated speech device. As I'm an app developer, we're a very tablet centric house, and the 10 inch tablets are far more difficult for all of the kids to drag around the house, not to mention the bulk when bringing it on outings to the park or restaurants. But the problem with an 8 inch tablet, is that since you need Windows 10 or IOS 10+ - you are left with really just a handful of devices, and the <b>Dell Venue Pro 8</b> offers a far greater battery life than anything else I've seen. This little power machine hasn't been made for a few years, but had great reviews, especially for its beautiful screen.</p> 

  <h3>Features</h3>
  <p> </p> 
  <ul>
    <li>5 to 12 hours battery life, depending on usage</li>
    <li>relatively loud speakers (no real need for external)</li>
    <li>8 inch screen allows for 15 large icon buttons, plus message bar</li>
    <li>screen glare has never been a problem</li>
	<li>very responsive screen with no lag time in speaking (our iPad pro, which insurance paid $7000 for, has a lag time!)</li>
	<li>sturdy protective case</li>
	<li>adorable neoprene carrying bag with soft handles & removable strap</li>
	<li>power charger & cord</li>
  </ul>
  
  
  
  <blockquote>If you can communicate, you can get by. But if you can communicate skillfully, you can work <i>miracles</i>.  - Jim Rohn</blockquote>
  
    <p> You can view the various aspects of our Talker device by navigating the menu. Thanks for visiting and, and give us a shout out as we're happy to answer any questions you have about the devices and materials. <a href="./topics/about">Click here to contact us.</a> </p>
  
</div>
<style>
.content {
	padding-top:20px;
	padding-bottom:50px;
} 

</style>

<script>
  import roadtrip from 'roadtrip';
    import Sharing from '../../components/Sharing.html';

  export default {
      store: () => store,
    components: { Sharing
	},
    methods: {
      goto(path) {
        roadtrip.goto(path);
      }
    },
	oncreate() {
		let activity = {
				"titles": ["Affordable AAC Device, the Talker. You can also find articles and graphics for use with your child's AAC device."],
				"subs": ["aac device"],
				"file": {
					"value": "home.html",
					"done": false
				},
				"tags": [],
				"dateRaw": "2019-02-21T19:04:22.815Z",
				"date": "Feb 21 2019",
				"settings": {
					"name": "home", 
					"img": "../img/talker_symbols/go.png",
					"desc": "Get a beautiful AAC device for around $300, customized for your child's needs.",
					"color": "navy", 
					"graphics": []
					}
				}
			
			  store.set({activity:activity});
	
	}	
  
  }
</script>